import type { DrawPoint } from "./types";

/**
 * Whether a viewport point falls inside a rect.
 *
 * Every surface adapter's `containsPoint` needs this, and each one was writing
 * it out longhand — so the next surface copied whichever version it found
 * first. Bounds are inclusive on all four edges, matching the behaviour the
 * adapters already had.
 */
export function rectContainsPoint(
  rect: DOMRect | null | undefined,
  point: DrawPoint,
): boolean {
  if (!rect) return false;
  return (
    point.x >= rect.left &&
    point.x <= rect.right &&
    point.y >= rect.top &&
    point.y <= rect.bottom
  );
}
